import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-3xl font-semibold text-ink">404</h1>
      <p className="text-graphite">That page doesn't exist.</p>
      <Link to="/" className="text-plum underline">Back to start</Link>
    </div>
  );
}
